export default function () {
  return [
    {
      type: 'Input',
      title: '组织层级',
      [$field]: 'allName',
      colSpan: 16,
      rules: ['']
    },
    // {
    //   type: 'Input',
    //   title: '团组织编码',
    //   [$field]: 'orgCode',
    //   rules: []
    // },
    {
      type: 'RemoteSelect',
      title: '团组织类别',
      [$field]: 'orgCategoryCode',
      rules: [''],
      readOnly: true,
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'ZB62',
          bizLineCode: 'YWX04'
        }
      }
    },
    {
      type: 'Input',
      title: '团组织全称',
      [$field]: 'orgName',
      colSpan: 16,
      rules: ['']
    },
    {
      type: 'Input',
      title: '团组织简称',
      [$field]: 'shortName',
      rules: ['']
    },
    {
      type: 'Input',
      title: '团组织书记',
      [$field]: 'principalUser',
      rules: []
    },
    // {
    //   type: 'Input',
    //   title: '团组织书记电话',
    //   [$field]: 'principalUserPhone',
    //   rules: ['']
    // },
    // {
    //   type: 'DatePicker',
    //   title: '团组织成立日期',
    //   [$field]: 'approvalBuildingDate'
    // },
    {
      type: 'Input',
      title: '上级团组织简称',
      [$field]: 'upShortName',
      rules: ['']
    },
    {
      type: 'Input',
      title: '上级团组织书记',
      readOnly: true,
      [$field]: 'upPrincipalUser'
    },
    {
      type: 'Input',
      title: '上上级团组织简称',
      [$field]: 'upUpShortName',
      rules: ['']
    },
    {
      type: 'Input',
      title: '上上级团组织书记',
      readOnly: true,
      [$field]: 'upUpPrincipalUser'
    },
    // {
    //   type: 'Input',
    //   title: '上级团组织书记电话',
    //   [$field]: 'upPrincipalUserPhone',
    //   rules: []
    // }
    {
      type: 'InputNumber',
      title: '本单位青年突击队数量',
      min: 0,
      [$field]: 'orgFieldaa',
      rules: [
        {
          validator (rule, value, resolve, reject) {
            if (value != null && !/^[1-9]\d*$/.test(value)) return resolve(new Error('只能输入正整数'))
            resolve()
          },
          trigger: 'change'
        }
      ]
    },
    {
      type: 'InputNumber',
      title: '集团认定青年突击队数量',
      min: 0,
      [$field]: 'orgFieldab',
      rules: [
        {
          validator (rule, value, resolve, reject) {
            if (value != null && !/^[1-9]\d*$/.test(value)) return resolve(new Error('只能输入正整数'))
            resolve()
          },
          trigger: 'change'
        }
      ]
    },
    // {
    //   title: '志愿者团队负责人',
    //   [$field]: 'orgFieldad',
    //   rules: []
    // },
    // {
    //   title: '志愿者团队负责人联系方式',
    //   [$field]: 'orgFieldae',
    //   rules: []
    // }
  ]
}